import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IRepairEstimate } from "@/models//repair-estimate.entity";
import repairEstimateService from "@/services/mrfiktiv/services/repair-estimate.service";
import { MrfiktivRepairEstimateControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const RepairEstimatePageDataProvider = new (class extends AbstractPageDataProvider<
  IRepairEstimate,
  MrfiktivRepairEstimateControllerGetParamsGen
> {
  itemsPerPage = 25;

  async getPage(query: MrfiktivRepairEstimateControllerGetParamsGen): Promise<IPageViewModel<IRepairEstimate>> {
    const res = await repairEstimateService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IRepairEstimate[];

    return { meta, data };
  }
})();
